import { React } from "react";
import { Row, Col } from "reactstrap";
import ItemCounter from "./ItemCounter";

const CartActionsSection = ({
  selectedItem,
  setSelectedItem,
  addToCart,
  isLoading,
  bgColor,

}) => {

  const handleQuantityChange = (newQuantity) => {
    if (selectedItem?.type === "item") {
      setSelectedItem((prev) => {
        const addonsTotal =
          prev.addons?.reduce(
            (sum, addon) => sum + addon.price * addon.quantity,
            0
          ) || 0;

        return {
          ...prev,
          quantity: newQuantity,
          totalPrice: Number(prev.price) * newQuantity + addonsTotal,
        };
      });
    } else {
      setSelectedItem((prev) => ({
        ...prev,
        quantity: newQuantity,
        totalPrice: Number(prev.price) * newQuantity,
      }));
    }
  };

  const isButtonDisabled = (!selectedItem.size && selectedItem?.type === "item");
  const totalPriceDisplay = selectedItem?.totalPrice;

  return (
    <Row className="w-100 mx-0 my-2 d-flex flex-column align-items-center justify-content-center">
      <Col className="col-12 col-sm-10 col-md-9 col-lg-6 col-xl-5 d-flex flex-column align-items-center">
        <ItemCounter
          selectedItem={selectedItem}
          setSelectedItemsSize={handleQuantityChange}
          bgColor={bgColor}
        />
        <button
          className="top_cards__addtocart fs--16 fw--500 my-2 w-100 btn py-3 text-white"
          style={{backgroundColor : bgColor}}
          onClick={addToCart}
          disabled={isButtonDisabled || isLoading}
        >
          {isButtonDisabled
            ? "Select size to add to cart"
            : `Add to cart - ${selectedItem?.currency || "$"}${totalPriceDisplay}`}
        </button>
      </Col>
    </Row>
  );
};

export default CartActionsSection;
